import { useNotificationContext } from 'bs-unified-ui';
import { UseNotificationsV2Result } from 'bs-unified-ui/components/Notification/useNotificationsV2';
import { useState, useEffect } from 'react';

export interface DeliveryRemindersStatus {
  taskUpdate: boolean;
  newDriver: boolean;
}

export const INDICATOR_MAPPING = {
  task_update: [
    'task_created',
    'task_completed',
    'task_failed',
    'failed_to_pick_up',
    'success_to_pick_up',
    'failed_to_return',
    'success_to_return',
    'import_task',
  ],
  new_driver: ['new_driver'],
};

const TASK_UPDATE_EVENTS = INDICATOR_MAPPING.task_update;
const NEW_DRIVER_EVENTS = INDICATOR_MAPPING.new_driver;

export const useDeliveryReminders = (): DeliveryRemindersStatus => {
  const context = useNotificationContext();

  if (!('allReminders' in context)) {
    return { taskUpdate: false, newDriver: false };
  }

  const { allReminders } = context as UseNotificationsV2Result;

  const checkReminders = (): DeliveryRemindersStatus => {
    let hasTaskUpdate = false;
    let hasNewDriver = false;

    allReminders.forEach((key) => {
      if (hasTaskUpdate && hasNewDriver) return;

      const eventType = key.includes(':') ? key.split(':')[0] : key;

      if (!hasTaskUpdate && TASK_UPDATE_EVENTS.includes(eventType as any)) {
        hasTaskUpdate = true;
      }

      if (!hasNewDriver && NEW_DRIVER_EVENTS.includes(eventType as any)) {
        hasNewDriver = true;
      }
    });

    return { taskUpdate: hasTaskUpdate, newDriver: hasNewDriver };
  };

  const [reminders, setReminders] =
    useState<DeliveryRemindersStatus>(checkReminders);

  useEffect(() => {
    const handleChange = () => {
      const newReminders = checkReminders();
      setReminders((prev) => {
        if (
          prev.taskUpdate !== newReminders.taskUpdate ||
          prev.newDriver !== newReminders.newDriver
        ) {
          return newReminders;
        }
        return prev;
      });
    };

    const unsubscribe = allReminders.subscribe(handleChange);

    return unsubscribe;
  }, [allReminders]);

  return reminders;
};
